// DateSelector.jsx

// Components
import DateDisplay from '@/components/data/date/DateDisplay';

// Styling
import { homeCss } from '@digital_monorepo/styling';
import { ICON_ARROW_RIGHT, ICON_ARROW_LEFT } from '@digital_monorepo/lib-common/assets/icons';

const DateSelector = ({ date, onPreviousWeek, onNextWeek, totalHours }) => {
  return (
    <div className={homeCss.singleLineSpaded}>
      <button className={homeCss.icon} onClick={onPreviousWeek}>
        <ICON_ARROW_LEFT />
      </button>
      <DateDisplay date={date.getUIDate()} totalHours={totalHours} />
      <button className={homeCss.icon} onClick={onNextWeek}>
        <ICON_ARROW_RIGHT />
      </button>
    </div>
  );
};

export default DateSelector;
